import React from 'react'
import Section from "../../../../Components/Section/Section";
import FormContainer from "../../../../Components/Form/FormContainer/FormContainer";
import Heading from "../../../../Components/Form/Heading/Heading";
import TextInput from "../../../../Components/Form/TextInput/TextInput";
import { formContent } from "./content"
import { useForm, FormProvider } from "react-hook-form";
import ImageSlider from "../../../../Components/Form/ImageSlider/ImageSlider";
import EventApi from "../../../../Api/EventApi";
import "../../../../bootstrap/bootstrap.min.css";
import MapView from "../../../../Components/Form/MapView/MapView";
import {faCalendarAlt, faDollarSign, faFileAlt} from "@fortawesome/free-solid-svg-icons";
import {
    getApiHost,
    getEventByIdFromSession,
    getResponseError,
    updateEventInSession
} from "../../../../Api/Utils/apiUtils";
import {formatDisplayDate} from "../../../../Api/Utils/dateUtils";
import ErrorAlert from "../../../../Components/Form/ErrorAlert/ErrorAlert";
import ExtraFeaturs from '../../../../Components/Accounts/Supplier/ExtraFeaturs/ExtraFeaturs';

const EventDetailsComponent = ({eventId}) => {
    let event = getEventByIdFromSession(parseInt(eventId));
    if(event) {
        event.eventDate = formatDisplayDate(event.eventDate);
    }
    const {eventImageInformationSet} = event;

    const {
        heading,
        eventDate,
        eventBudget,
        eventDescription,
        eventAddress,
        state,
        latitude,
        longitude,
    } = formContent;

    const [errorMessage, setErrorMessage] = React.useState(null);
    const formBinding = useForm({defaultValues: event});
    const { watch } = formBinding;
    watch(() => setErrorMessage(''));

    const addEventImage = async (imageUrl) => {

        const payload = { eventId, imageUrl }
        const response = await EventApi.addEventImage(payload);
        const apiError = getResponseError(response);
        if(apiError){
            setErrorMessage(apiError);
        } else {
            const uploadedImage = response.objectVal;
            let url = uploadedImage.imageUrl;
            if (url.indexOf('upload') === 0) {
                url = getApiHost() + '/' + url;
            }
            uploadedImage.url = url;
            event.eventImageInformationSet.unshift(uploadedImage);
            updateEventInSession(event);
            return uploadedImage;
        }
    }

    const deleteEventImage = async (data) => {
        data.eventId = eventId;
        const response = await EventApi.deleteEventImage(data);
        const apiError = getResponseError(response);
        if(apiError){
            setErrorMessage(apiError);
        } else {
            event.eventImageInformationSet = event.eventImageInformationSet.filter(e => e.id !== data.id);
            updateEventInSession(event);
        }
    }

    const updateBudget = async (budget) => {
        const payload = { eventId, budget }
        const response = await EventApi.addEventBudget(payload);
        const apiError = getResponseError(response);
        if(apiError){
            setErrorMessage(apiError);
        } else {
            event = {...event, ...payload};
            updateEventInSession(event);
        }
    }

    const updateEventDescription = async (description) => {
        const payload = { eventId, description }
        const response = await EventApi.addEventDescription(payload);
        const apiError = getResponseError(response);
        if(apiError){
            setErrorMessage(apiError);
        } else {
            event = {...event, ...payload};
            updateEventInSession(event);
        }
    }

    const updateEventAddress = async (data) => {
        const { address, state, latitude, longitude } = data;
        const payload = {
            eventId,
            address,
            state,
            latitude,
            longitude
        }
        const response = await EventApi.addEventDescription(payload);
        const apiError = getResponseError(response);
        if(apiError){
            setErrorMessage(apiError);
        } else {
            event = {...event, ...payload};
            updateEventInSession(event);
        }
    }

    return (
        <Section>
            <FormContainer>
                <Heading>{heading}</Heading>
                <ErrorAlert>{errorMessage}</ErrorAlert>
                <FormProvider {...formBinding}>
                    <form id="event-details-form">
                        <ImageSlider images={eventImageInformationSet}
                               addImageFunction={addEventImage}  deleteImageFunction={deleteEventImage}/>
                        <TextInput {...eventDate} labelIcon={faCalendarAlt}/>
                        <TextInput {...eventBudget} labelIcon={faDollarSign}
                               editFieldInModal={true}
                               editFieldAction={updateBudget}/>
                        <TextInput {...eventDescription} labelIcon={faFileAlt}
                               editFieldInModal={true}
                               editFieldAction={updateEventDescription}/>
                        <MapView eventAddress={eventAddress} data={event} updateAddressAction={updateEventAddress}></MapView>
                        <TextInput {...state} />
                        <TextInput {...latitude} />
                        <TextInput {...longitude} />
                    </form>
                </FormProvider>
                <ExtraFeaturs eventid={eventId} seErr={setErrorMessage} />
            </FormContainer>
        </Section>
    )
}

export default EventDetailsComponent
